import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from 'vue-auto-routing';
import { createRouterLayout } from 'vue-router-layout';

Vue.use(VueRouter);

// eslint-disable-next-line arrow-body-style
const RouterLayout = createRouterLayout((layout) => {
  // eslint-disable-next-line prefer-template
  return import('@/layouts/' + layout + '.vue');
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes,
    },
  ],
});

export default router;
